import request, { GET } from '../utils/request';

export const apiGetCjAppointmentConversion = (
  appointmentId,
  appointmentPrice,
  country,
  promoCode,
  cjEvent,
) =>
  request(GET, `${CONFIG.API_URL}/cj-affiliate/conversion/${appointmentId}`, {
    params: {
      appointmentPrice,
      country,
      promoCode,
      cjEvent,
    },
  });

export const apiGetCjPatientConversion = (patientId, cjEvent) =>
  request(
    GET,
    `${CONFIG.API_URL}/cj-affiliate/patient/${patientId}/conversion`,
    {
      params: {
        cjEvent,
      },
    },
  );
